module.exports = "<div data-list-container></div>\n<div data-modal-container></div>\n"